const AUDIENCES = ["customer", "internal"];

function snapshotValue(value) {
  if (value == null) {
    return "";
  }
  return String(value);
}

export function knowledgeDraftSnapshot(fields) {
  const source = fields && typeof fields === "object" ? fields : {};
  return {
    factId: snapshotValue(source.factId),
    revision: snapshotValue(source.revision),
    topicKey: snapshotValue(source.topicKey),
    text: snapshotValue(source.text),
    language: snapshotValue(source.language),
    audience: snapshotValue(source.audience),
    ownerRef: snapshotValue(source.ownerRef),
    expectedRevision: snapshotValue(source.expectedRevision),
  };
}

function sameSnapshot(left, right) {
  return Object.keys(left).every((key) => left[key] === right[key]);
}

export function resolveKnowledgeDraftCommand(previous, fields, createCommand) {
  const snapshot = knowledgeDraftSnapshot(fields);
  if (
    previous
    && typeof previous.commandId === "string"
    && previous.commandId !== ""
    && typeof previous.asOf === "string"
    && previous.asOf !== ""
    && previous.fields
    && sameSnapshot(previous.fields, snapshot)
  ) {
    return previous;
  }
  const created = createCommand();
  return {
    commandId: created.commandId,
    asOf: created.asOf,
    fields: snapshot,
  };
}

function requiredText(value) {
  if (typeof value !== "string" || value === "") {
    return null;
  }
  return value;
}

function wholeNumber(value) {
  if (typeof value === "number") {
    if (!Number.isSafeInteger(value) || value < 0) {
      return undefined;
    }
    return value;
  }
  if (value == null || value === "") {
    return null;
  }
  if (typeof value !== "string" || !/^(0|[1-9]\d*)$/.test(value)) {
    return undefined;
  }
  const parsed = Number(value);
  if (!Number.isSafeInteger(parsed)) {
    return undefined;
  }
  return parsed;
}

export function buildKnowledgeDraftBody({ commandId, asOf, fields }) {
  const source = fields && typeof fields === "object" ? fields : {};
  const factId = requiredText(source.factId);
  const topicKey = requiredText(source.topicKey);
  const language = requiredText(source.language);
  const audience = requiredText(source.audience);
  const ownerRef = requiredText(source.ownerRef);
  const revision = wholeNumber(source.revision);
  const expectedRevision = wholeNumber(source.expectedRevision);
  if (
    typeof commandId !== "string"
    || commandId === ""
    || typeof asOf !== "string"
    || asOf === ""
    || factId == null
    || topicKey == null
    || language == null
    || audience == null
    || !AUDIENCES.includes(audience)
    || ownerRef == null
    || revision == null
    || expectedRevision === undefined
  ) {
    return { error: "empty" };
  }
  const fact = {
    fact_id: factId,
    revision,
    topic_key: topicKey,
    approved_text_or_typed_value: source.text == null ? "" : String(source.text),
    language,
    audience,
    owner_ref: ownerRef,
    status: "draft",
  };
  const body = {
    command_id: commandId,
    as_of: asOf,
    fact,
  };
  if (expectedRevision != null) {
    body.expected_revision = expectedRevision;
  }
  return { body };
}

export function knowledgeDraftSaveFollowUp({ outcome, status, reloadFailed, detail }) {
  if (outcome === "applied" || outcome === "replayed") {
    if (reloadFailed) {
      return {
        saved: true,
        replaceList: false,
        notice: "Draft saved. The list could not be reloaded.",
      };
    }
    return { saved: true, replaceList: true, notice: "Draft saved." };
  }
  const refused = status === 403 || status === 409 || status === 422;
  const notice = refused && typeof detail === "string" && detail !== ""
    ? detail
    : "Draft was not saved.";
  if (refused && reloadFailed) {
    return {
      saved: false,
      replaceList: false,
      reload: false,
      notice: `${notice} The list could not be reloaded.`,
    };
  }
  return { saved: false, replaceList: false, reload: refused, notice };
}
